import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api';
import { CFormLabel } from '@coreui/react';
import { Spinner } from 'react-bootstrap';

const ProviderPastOrder = ({ patientID, noteID, headerShow = true  }) => {
   
    const [ordersData, setOrdersData] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [orders, setOrders] = useState([])

     console.log('order data===>', orders)
    const GetPatientTreatmentsNotes = async () => {
        setIsPageLoading(true)
        try {
            let data
            data = await PatientNoteDataCRUD("GET", patientID);
            if (data) {
                data = JSON.parse(data.d)?.Data;
                data = data.map((item) => {
                    return {
                        ...item,
                        data: item.data ? JSON.parse(item?.data) : {},
                    }
                })
                console.log("notestructureenotestructuree", data)

                if(noteID > 0)
                {
                    let orders = data[parseInt(noteID) -1]?.data?.plans
                    console.log("orders", orders)
                }

                // setPatientTreatments(data);


                return data
            }
        } catch (error) {
            console.error('error in patient treatment',error)
        } finally {
            setIsPageLoading(false)
        }
    }

    const fetchOrders = async () => {
        setIsPageLoading(true)
        try {

            let data = await PatientOrdersCRUD('Get', "", patientID);

            data = JSON.parse(data?.d).Data || [];
            console.log("orders data", data)
            const parsedOrders = data?.map(order => ({
                // ...order,
                date: order.date,
                medication: JSON.parse(order.medication)
            }))
                .filter(item => item.medication?.noteID === (parseInt(noteID) - 1))

           
            setOrders(parsedOrders)

        } catch (error) {
            console.error('Failed to fetch or parse orders:', error);
        }finally{
            setIsPageLoading(false)
        }
        
    };


 
    useEffect(() => {
        fetchOrders()
    }, [])
    return (
        <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
            <h5 style={{ display: headerShow ? 'block' : 'none' }}>Previous Order</h5>

           { isPageLoading ? <Spinner  /> : 
           <div className="rounded d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
                <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflowY: 'auto', overflowX: 'hidden', paddingRight: '6px' }}>
                {orders?.length > 0 ?
                    orders.map((item, idx) => {
                        const currentOrder = item?.medication;
                        return (
                            <div key={idx} className="mb-3">
                                <div className="card shadow-sm" style={{background:'#191919', maxWidth: '100%', overflowWrap: 'anywhere'}}>
                                    <div className="card-body" >

                                        {/* Date */}
                                        <div className="">
                                            <div>
                                                <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                                {(() => {
                                                    if (!item?.date) return;
                                                    const parts = item?.date?.split("-");
                                                    if (!parts || parts.length !== 3) return "";
                                                    const [ month,day, year] = parts;
                                                    const date = new Date(`${year}-${month}-${day}`);
                                                    return new Intl.DateTimeFormat("en-US", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric",
                                                    }).format(date);
                                                })()}
                                            </div>
                                            {currentOrder?.diagnosis && (
                                                <p className="mb-1 " style={{ marginTop: '-8px' }}>
                                                    <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                                </p>
                                            )}
                                        </div>



                                        {/* Imaging */}
                                        {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                            <div className="mb-2">
                                                <p className="text-secondary fw-bold mb-1">Imaging</p>
                                                <ul>
                                                    {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                                                        <li className="p-0 m-0" key={iIdx}>
                                                            {imagingItem?.type}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Labs */}
                                        {currentOrder?.lab?.labs?.length > 0 && (
                                            <div className="mb-2">
                                                <p className="text-secondary fw-bold mb-1">Labs</p>
                                                <ul>
                                                    {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                        <li className="p-0 m-0" key={lIdx}>
                                                            {labItem?.lab}
                                                            {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Medications */}
                                        {currentOrder?.medication?.medication?.length > 0 && (
                                            <div className="mb-2">
                                                <p className="text-secondary fw-bold mb-1">Medications</p>
                                                <ul>
                                                    {currentOrder.medication.medication.map((medItem, mIdx) => (
                                                        <li className="p-0 m-0" key={mIdx}>
                                                            {medItem?.name} {medItem?.dosage} {medItem?.route}
                                                            {medItem?.frequency && ` ${medItem.frequency}`}
                                                            {medItem?.reason && ` - ${medItem.reason}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Miscellaneous */}
                                        {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                            <div className="mb-2">
                                                <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                                <ul>
                                                    {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                                        <li className="p-0 m-0" key={xIdx}>
                                                            {miscItem}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>


                        );
                    }) : <div className="text-center text-muted py-3">
                        No orders available.
                    </div>}
                </div>
            </div>}
        </div>
    )
}

export default ProviderPastOrder
